export interface ReferralTemplateInput {
  specialistName: string;
  practiceName?: string | null;
  address?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  referralMethod?: string | null;
  referralNotes?: string | null;
}

export function buildReferralTemplate(input: ReferralTemplateInput): string {
  const destination = [
    clean(input.specialistName),
    clean(input.practiceName),
    clean(input.address),
    labelled("Phone", input.phone),
    labelled("Fax", input.fax),
    labelled("Email", input.email),
    labelled("Referral method", input.referralMethod),
  ].filter((line): line is string => Boolean(line));
  const notes = clean(input.referralNotes);

  return [
    `Dear ${clean(input.specialistName) ?? "Specialist"},`,
    "",
    "Re: [Patient name]",
    "DOB: [DOB]",
    "",
    "Reason for referral:",
    "[Reason for referral]",
    "",
    "Relevant history:",
    "[Relevant history]",
    "",
    "Medications:",
    "[Medications]",
    "",
    "Urgency:",
    "[Urgency]",
    ...(notes ? ["", "Please include:", notes] : []),
    "",
    "Referral destination:",
    ...destination,
  ].join("\n");
}

function labelled(label: string, value: string | null | undefined): string | null {
  const cleaned = clean(value);
  return cleaned ? `${label}: ${cleaned}` : null;
}

function clean(value: string | null | undefined): string | null {
  const cleaned = value?.trim();
  return cleaned || null;
}
